export function renderGenDistinctFilesServerActionTemplate({
  ctxTableVar,
  ctxCacheReadImport,
  ctxCamelPlural,
  ctxPlural,
  fieldPascal,
  ctxCacheLifeLine,
  filterField,
  ctxPluralText
}: {
  ctxTableVar: string
  ctxCacheReadImport: string
  ctxCamelPlural: string
  ctxPlural: string
  fieldPascal: string
  ctxCacheLifeLine: string
  filterField: string
  ctxPluralText: string
}): string {
  return `'use server'

import db from '@admin/db'
import { ${ctxTableVar} } from '@admin/db/schema'
import { asc, isNotNull } from 'drizzle-orm'
${ctxCacheReadImport}
import { ${ctxCamelPlural}CacheTags } from './types'

export async function getDistinct${ctxPlural}${fieldPascal}(): Promise<string[]> {
  'use cache'${ctxCacheLifeLine}
  cacheTag(${ctxCamelPlural}CacheTags.all)

  try {
    const results = await db
      .selectDistinct({ value: ${ctxTableVar}.${filterField} })
      .from(${ctxTableVar})
      .where(isNotNull(${ctxTableVar}.${filterField}))
      .orderBy(asc(${ctxTableVar}.${filterField}))
    return results.map((r) => String(r.value)).filter(Boolean)
  } catch (error) {
    console.error('Error fetching distinct ${ctxPluralText} ${filterField}:', error)
    return []
  }
}
`
}
